<template>
  <div class="my-tr1-box" ref="tr">
    <slot></slot>
  </div>
</template>
<script>
// <Tr1></Tr1>
export default {
  name: "Tr1",
  props: {},
  data() {
    return {}
  },
  methods: {},
  mounted() {
    let parantsDom = this.$refs.tr
    let parantsDomHeight = window.getComputedStyle(parantsDom).height
    let childNodes = parantsDom.childNodes

    for (let i = 0; i < childNodes.length; i++) {
      if (childNodes[i].nodeType === 1) {
        childNodes[i].style.height = parantsDomHeight
      }
    }
  },
  destroyed() {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.my-tr1-box {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  width: 100%;
  min-height: 54px;
  border: 1px solid rgba(228, 231, 237, 1);
  border-bottom: none;
  background: rgba(245, 247, 250, 1);
  &:last-child {
    border-bottom: 1px solid rgba(228, 231, 237, 1);
  }
}
</style>
